// extracted by mini-css-extract-plugin
module.exports = {"idea_title":"lets-link-idea_idea_title__Pu7Gv","idea_text":"lets-link-idea_idea_text__peqCf","idea_image":"lets-link-idea_idea_image__b3Rr_"};